module.exports = require('./helpers/bundle-url').getBundleURL('hcTqB') + "PartyPopper.17a1bdf3.svg";